
import Vue from 'vue'
import MainLayout from '@/components/MainLayout.vue';
import ContentNode from '@/components/ContentNode.vue';
import { format } from 'date-fns'
import { ContentResponse } from '@chainsight/fad-backend-axios-sdk';
import VueSocialSharing from 'vue-social-sharing';
import { Carousel, Slide } from 'vue-carousel';
import copy from 'copy-to-clipboard';
Vue.use(VueSocialSharing);


export default Vue.extend({
    name: 'Blog',
    components: {
        MainLayout,
        ContentNode,
    },
    data() {
        return {
            socialMedia: [
                { icon: "linkedin.png", iconHover: "linkedin-dark.png", alt: "linkedin" },
                { icon: "twitter.png", iconHover: "twitter-dark.png", alt: "twitter" },
                { icon: "telegram.png", iconHover: "telegram-dark.png", alt: "telegram" },
                // { icon: "discord.png", iconHover: "discord-dark.png", alt: "discord" },
                { icon: "facebook.png", iconHover: "facebook-dark.png", alt: "facebook" }
            ],
            heroImageUrl: '',
            contentResponse: null as unknown as ContentResponse,
            contentDate: '',
            contentInfoList: [{
                id: null as unknown as string,
                title: null as unknown as string,
                heroImageUrl: null as unknown as string
            }],
            isCopied: false
        };
    },
    computed: {
        contentUrl() {
            return window.origin+'/blog?contentId='+this.$route.query.contentId;
        }
    },
    methods: {
        changeContentId(newContentId: string) {
            // this.$router.push({ path: '/blog', query: { contentId: newContentId } })
            location.href = window.origin+'/blog?contentId='+newContentId
        },
        async getContent(contentId: string) {
            let contentData
            try{
                contentData = await this.api$.contentfulApi.entry(contentId)
            }catch (error) {
                this.$router.replace('/');
                console.error(error)
            }
            this.contentResponse = contentData.data;

            const date = new Date(contentData.data.sys?.createdAt as string);
            this.contentDate = format(date, 'MMM dd, yyyy')

            let imageData
            try{
                imageData = await this.api$.contentfulApi.asset(this.contentResponse.fields?.heroImage?.sys?.id as string)
            }catch (error) {
                console.error(error)
            }
            this.heroImageUrl = imageData.data.fields?.file.url;
        },
        async getContents() {
            let contentData
            try{
                contentData = await this.api$.contentfulApi.entries();
            }catch (error) {
                console.error(error)
            }
            
            interface ContentsItem {
                id:  string,
                title:  string,
                heroImageUrl:  string
            };
            let contents: ContentsItem[] =[]

            contentData.data.items!.forEach( (item) => {
                const contentsItem: ContentsItem = {
                    id: item.sys?.id as string,
                    title: item.fields?.title as string,
                    heroImageUrl: '' as string
                }

                this.api$.contentfulApi.asset(item.fields?.heroImage?.sys?.id as string)
                    .then(resp => {
                        contentsItem.heroImageUrl = resp.data.fields?.file.url
                    }).catch( (error) => {
                        console.error(error)
                    })
                contents.push(contentsItem)      
            })
            this.contentInfoList = contents
        },
        copyUrl() {
            copy(this.contentUrl);
            this.isCopied = true
            setTimeout(() =>{
                this.isCopied = false
            }, 3000)
        }
    },
    created() {
        this.getContent(this.$route.query.contentId as string);
        this.getContents();
    },
    watch:{
        "$route.query.contentId": {
            handler: function(value) {
                this.getContent(this.$route.query.contentId as string);
            },
            deep: true,
            immediate: true,
        },
    }
});
